import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Venta } from 'src/app/model/index.model';
import { firstValueFrom } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class VentaService extends BaseService<Venta> {

    constructor(protected override http: HttpClient) {
        super(http, 'venta');
    }

    doFindByUsuario(id, page, limit) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get(this.api + "/byUser/" + id + "?page=" + page + "&limit=" + limit, { headers: this.other_header })
        );
    }
    doFindByPrint(id) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .get(this.api + "/byPrint/" + id, { headers: this.other_header })
        );
    }

}
